import { createContext } from 'react';

export const UAContext = createContext({ isMac: false, isSafari: false });

export const IdContext = createContext(false);
